import { Card } from "@/components/common";
import SectionHeader from "./SectionHeader";
import { motion } from "framer-motion";

const AiccSection = () => {
  return (
    <section className="py-12 bg-white border-t border-gray-100 sm:py-24">
      <div className="max-w-[132rem] mx-auto px-4 sm:px-8">
        {/* 섹션 헤더 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <SectionHeader
            title={
              <>
                설치 없이 바로 쓰는 <span className="text-[#1976D2]">문자콜센터</span>
              </>
            }
            description="개발 부담 없이, 자연어 명령으로 고객 상담 환경을 빠르게 구축하세요."
            buttonText="서비스 알아보기"
            buttonTo="/service-provide/voucher-aicc"
          />
        </motion.div>

        {/* 콘텐츠 영역 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="grid items-center grid-cols-1 gap-8 pt-10 sm:pt-20 md:grid-cols-2">
            {/* 왼쪽 - 이미지 */}
            <div className="flex items-end justify-center">
              <img
                src="/img/home/aicc/aicc_01.png"
                alt="문자콜센터 모바일"
                className="object-contain w-full h-auto max-w-[300px] sm:max-w-[500px]"
              />
            </div>

            {/* 오른쪽 - 특징 리스트 */}
            <div className="pb-5">
              <div className="flex items-center justify-center">
                <img
                  src="/img/home/aicc/aicc_02.png"
                  alt="문자콜센터 모바일"
                  className="object-contain w-full h-auto max-w-[200px] sm:max-w-[320px] relative top-8 sm:top-16"
                />
              </div>
              <div className="relative space-y-3 z-1">
                <Card className="flex items-center justify-center gap-2 px-3 py-4 sm:gap-3 sm:py-8 sm:px-6">
                  <span className="material-icons-round text-[2rem] sm:text-[3rem] text-[#1976D2]">
                    smart_toy
                  </span>
                  <p className="text-[1.3rem] sm:text-[1.7rem] md:text-[1.9rem] text-gray-700">
                    AI가 채팅 응대부터 전화 라우팅까지 <span className="font-bold">자동 처리</span>
                  </p>
                </Card>

                <Card className="flex items-center justify-center gap-2 px-3 py-4 sm:gap-3 sm:py-8 sm:px-6">
                  <span className="material-icons-round text-[2rem] sm:text-[3rem] text-[#1976D2]">
                    phone_in_talk
                  </span>
                  <p className="text-[1.3rem] sm:text-[1.7rem] md:text-[1.9rem] text-gray-700">
                    메시지부터 통화까지, 하나로 이어지는{" "}
                    <span className="font-bold">통화 상담 이력</span>
                  </p>
                </Card>

                <Card className="flex items-center justify-center gap-2 px-3 py-4 sm:gap-3 sm:py-8 sm:px-6">
                  <span className="material-icons-round text-[2rem] sm:text-[3rem] text-[#1976D2]">
                    bolt
                  </span>
                  <p className="text-[1.3rem] sm:text-[1.7rem] md:text-[1.9rem] text-gray-700">
                    구축부터 운영까지 <span className="font-bold">쉽고 빠르게 합리적인 비용</span>
                    으로
                  </p>
                </Card>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AiccSection;
